// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement-class[data-v-cdf15d5a] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
